
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway, ConsumerCenter } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class ConsumerCenterEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    consumerCenter!: ConsumerCenter;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getConsumerCenter()]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getConsumerCenter(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.consumerCenter = data;
                this.onDataChanged.next(this.consumerCenter);
                resolve(this.consumerCenter);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('consumerCenter/' + this.routeParams.id).subscribe({next:(res: ConsumerCenter ) => {
                    this.consumerCenter = res;
                    this.onDataChanged.next(this.consumerCenter);
                    resolve(res);
                }, error: (err: any) => { reject(err) }});
            }
        });
    }

    insert(consumerCenter :ConsumerCenter): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('consumerCenter/', consumerCenter).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    edit(consumerCenter :ConsumerCenter): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('consumerCenter/', consumerCenter).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    delete(consumerCenter :ConsumerCenter): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('consumerCenter/' + consumerCenter.id).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    checkLastModifications(): ConsumerCenter | null {
        const sessionLocked = localStorage.getItem('session_locked');
        const wasLocked = sessionLocked ? JSON.parse(sessionLocked) : null;
        let data: ConsumerCenter | null = null;
        if (wasLocked){
            const lastModification = localStorage.getItem('last_modification');
            data = lastModification ? JSON.parse(lastModification) : null;
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
